import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles, alpha } from '@material-ui/core'

/** Lighter fill + narrow bright band so the wave reads clearly */
const skeletonWaveAfter = (theme: Theme) => ({
  '&::after': {
    background: `linear-gradient(90deg, transparent 30%, ${alpha(
      theme.palette.common.white,
      0.82
    )} 50%, transparent 70%)`,
  },
})

export const useListedItemPlaceholderStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: theme.shape.borderRadius * 2,
      border: `1px solid ${theme.palette.divider}`,
      overflow: 'hidden',
      pointerEvents: 'none',
      [theme.breakpoints.down('sm')]: {
        borderRadius: theme.shape.borderRadius,
      },
    },
    cardContent: {
      padding: theme.spacing(2.5),
      flex: 1,
      '&:last-child': {
        paddingBottom: theme.spacing(2.5),
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
        '&:last-child': {
          paddingBottom: theme.spacing(2),
        },
      },
    },
    image: {
      paddingTop: '100%',
      transform: 'scale(1)',
      height: '0.001em',
      backgroundColor: alpha(theme.palette.text.primary, 0.12),
      ...skeletonWaveAfter(theme),
    },
    textHolder: {
      marginTop: 10,
    },
    textLine: {
      backgroundColor: alpha(theme.palette.text.primary, 0.12),
      ...skeletonWaveAfter(theme),
    },
  })
)
